import { render, staticRenderFns } from "./UserCreationDialog.vue?vue&type=template&id=031ae0ea&scoped=true"
import script from "./UserCreationDialog.ts?vue&type=script&lang=ts&external"
export * from "./UserCreationDialog.ts?vue&type=script&lang=ts&external"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "031ae0ea",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/codebuild/output/src120839944/src/sctd-frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('031ae0ea')) {
      api.createRecord('031ae0ea', component.options)
    } else {
      api.reload('031ae0ea', component.options)
    }
    module.hot.accept("./UserCreationDialog.vue?vue&type=template&id=031ae0ea&scoped=true", function () {
      api.rerender('031ae0ea', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/Modules/UsersManager/components/dialogs/UserCreationDialog/UserCreationDialog.vue"
export default component.exports